/**
 * List of slugs that are utilities.
 * @type {string[]}
 */
export const SPECIAL_UTILITY_SLUGS = ['csv', 'xml', 'zip', 'fileConverter', 'pGPEncryption'];
export const BASE_UTILITY_SLUGS = [
  'schedule', //
  'webhook',
  'transform',
  'map',
  'iterate',
  'wait',
  'flowControl',
  'ifElse',
  'webhookResponse',
  'continue',
  'memory',
  'runWorkflow',
  'break',
  'httpRequest',
  'groupResults'
];
export const UTILITY_SLUGS = [...SPECIAL_UTILITY_SLUGS, ...BASE_UTILITY_SLUGS];

export const SELECTOR_SLUGS = ['appSelector', 'triggerSelector', 'appTriggerSelector'];

/**
 * List of slugs that are not allowed for publishing.
 * @type {string[]}
 */
export const NON_PUBLISHABLE_SLUGS = [];

/**
 * List of slugs that are not allowed to run as a single step.
 * @type {string[]}
 */
export const NON_RUNNABLE_SLUGS = ['webhook', 'schedule', 'iterate', 'wait', 'flowControl', 'webhookResponse', 'continue', 'appSelector', 'functionInputs', 'break'];

/**
 * List of slugs that should not run flow control.
 * @type {string[]}
 */
export const NON_FLOW_CONTROL_SLUGS = [
  ...NON_RUNNABLE_SLUGS, //
  ...BASE_UTILITY_SLUGS.filter((slug) => slug !== 'httpRequest')
];

/**
 * List of blacklisted email domains.
 * @type {string[]}
 */
export const BLACKLISTED_DOMAINS = [
  // Popular email providers
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'msn.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'protonmail.com',
  'zoho.com',
  'yandex.com',
  'gmx.com',
  'mail.com',
  'mail.ru',
  // Disposable email providers
  '0815.ru',
  '0cd.cn',
  '10minmail.de',
  '10minutenmail.xyz',
  '15963.fr.nf',
  '1mail.x24hr.com',
  '1xp.fr',
  '23.8.dnsabr.com',
  '24hinbox.com',
  '47tiger.site',
  '54.mk',
  '8.dnsabr.com',
  '8259law.com',
  '888.dns-cloud.net',
  'a.kwtest.io',
  'a1b2.cloudns.ph',
  'aaqwe.ru',
  'aaqwe.store',
  'ab34.fr',
  'abo-free.fr.nf',
  'ac-cool.c4.fr',
  'ac-malin.fr.nf',
  'accidentals.online',
  'acname.com',
  'actarus.infos.st',
  'activego.store',
  'addedbyjc.0rg.fr',
  'adresse.biz.st',
  'adresse.fr.cr',
  'adresse.infos.st',
  'adult-work.info',
  'afw.fr.nf',
  'ag.prout.be',
  'agaseo.com',
  'alphax.fr.nf',
  'altrans.fr.nf',
  'alves.fr.nf',
  'alyxgod.rf.gd',
  'antispam.fr.nf',
  'armyspy.com',
  'art.fr.cr',
  'as10.ddnsfree.com',
  'asanyavacations.com',
  'asia.dnsabr.com',
  'askold.prout.be',
  'assurmail.net',
  'atriox.rf.gd',
  'autre.fr.nf',
  'available-home.com',
  'awgarstone.com',
  'aze.kwtest.io',
  'azeqsd.fr.nf',
  'b.cr.cloudns.asia',
  'b7s.ru',
  'ba.prout.be',
  'bahoo.biz.st',
  'bboys.fr.nf',
  'bd.dns-cloud.net',
  'becknellsbakery.com',
  'bibi.biz.st',
  'bin-ich.com',
  'binich.com',
  'bmn.ch.ma',
  'bobgf.ru',
  'bobgf.store',
  'boranora.com',
  'borealinbox.com',
  'box-mail.ru',
  'box-mail.store',
  'boxem.ru',
  'boxem.store',
  'boxlet.ru',
  'boxlet.store',
  'brand-app.biz',
  'breaksmedia.com',
  'breizh.im',
  'btcmod.com',
  'buzblox.com',
  'byom.de',
  'c-eric.fr.cr',
  'c-eric.fr.nf',
  'cabiste.fr.nf',
  'calendro.fr.nf',
  'calima.asso.st',
  'candymail.de',
  'carioca.biz.st',
  'carnesa.biz.st',
  'cazlp.com',
  'cazlq.com',
  'cbty.ru',
  'cbty.store',
  'certexx.fr.nf',
  'chaocosen.com',
  'cheznico.fr.cr',
  'citmo.net',
  'ckptr.com',
  'clip.lat',
  'closetab.email',
  'cobal.infos.st',
  'code-gmail.com',
  'contact.biz.st',
  'contact.infos.st',
  'cookie007.fr.nf',
  'cool.fr.nf',
  'courriel.fr.nf',
  'courrier.fr.cr',
  'cpc.cx',
  'cr.cloudns.asia',
  'cubox.biz.st',
  'cuvox.de',
  'cwmxc.com',
  'cwrotzxks.com',
  'danangsale.net',
  'dao.pp.ua',
  'darksirius.shop',
  'dayrep.com',
  'dede.infos.st',
  'degap.fr.nf',
  'deligy.com',
  'desfrenes.fr.nf',
  'dilnoe.com',
  'dis.hopto.org',
  'discard.email',
  'discardmail.com',
  'discardmail.de',
  'discorded.io',
  'dispo.sebbcn.net',
  'dlvr.us.to',
  'dmcihouse.net',
  'dmts.fr.nf',
  'domaaain16.online',
  'domaain38.online',
  'doneemail.com',
  'doublemail.de',
  'doviaso.fr.cr',
  'dreamgreen.fr.nf',
  'dripzgaming.com',
  'druzik.pp.ua',
  'dsgvo.party',
  'dvd.dns-cloud.net',
  'dvd.dnsabr.com',
  'dxice.com',
  'e3b.org',
  'ealea.fr.nf',
  'einrot.com',
  'elmail.4pu.com',
  'elpifrance.com',
  'em2lab.com',
  'email-temp.com',
  'email.jjj.ee',
  'emaildark.fr.nf',
  'epbox.ru',
  'epbox.store',
  'epostal.ru',
  'epostal.store',
  'eqntfrue.com',
  'es.prout.be',
  'etopys.com',
  'eu.dns-cloud.net',
  'eu.dnsabr.com',
  'eureka.0rg.fr',
  'existiert.net',
  'ezigolife.com',
  'fake-box.com',
  'fakemailserver.com',
  'fasssd.ru',
  'fasssd.store',
  'fbtank.org',
  'fhpfhp.fr.nf',
  'fleckens.hu',
  'fliegender.fish',
  'flobo.fr.nf',
  'fncp.ru',
  'fncp.store',
  'fosiq.com',
  'foxyjazzabelle.com',
  'freemail.biz.st',
  'freemail.fr.cr',
  'freundin.ru',
  'from.onmypc.info',
  'frostmail.fr.cr',
  'frostmail.fr.nf',
  'fukaru.com',
  'funnymail.de',
  'funvane.com',
  'fuppurge.info',
  'fuvk.ru',
  'fuvk.store',
  'galaxim.fr.nf',
  'ggamess.42web.io',
  'gggggg.fr.cr',
  'ggmail.biz.st',
  'ggvk.ru',
  'ggvk.store',
  'gimuemoa.fr.nf',
  'gladogmi.fr.nf',
  'glalen.com',
  'gland.xxl.st',
  'greendike.com',
  'grr.la',
  'gruene-nein-danke.xyz',
  'gudri.com',
  'guerrillamail.biz',
  'guerrillamail.com',
  'guerrillamail.de',
  'guerrillamail.info',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamailblock.com',
  'gustr.com',
  'haben-wir.com',
  'habenwir.com',
  'haislot.com',
  'halcyon.work',
  'hi2.in',
  'hieu.in',
  'himail.infos.st',
  'hotbird.giize.com',
  'hotmail.red',
  'hulas.me',
  'hunnur.com',
  'hxopi.ru',
  'hxopi.store',
  'ich-esse-fleisch.bio',
  'icidroit.info',
  'idsho.com',
  'igdinhcao.com',
  'igduylam.click',
  'ilebi.com',
  'iliken.com',
  'imagepoet.net',
  'imails.asso.st',
  'imap.fr.nf',
  'inboxnow.ru',
  'inboxnow.store',
  'internaut.us.to',
  'isep.fr.nf',
  'iskiie.dev',
  'ist-hier.com',
  'iya.fr.nf',
  'jackymel.xl.cx',
  'jaga.email',
  'jetable.fr.nf',
  'jetable.org',
  'ji5.de',
  'ji6.de',
  'ji7.de',
  'jinva.fr.nf',
  'jmail.fr.nf',
  'jourrapide.com',
  'katanajp.wiki',
  'kavaint.net',
  'knickerbockerban.de',
  'koes.justdied.com',
  'korekgas.info',
  'kravify.com',
  'kyuusei.fr.nf',
  'lacraffe.fr.nf',
  'lambsauce.de',
  'latsoukabe.com',
  'laxex.ru',
  'laxex.store',
  'le.monchu.fr',
  'lechatiao.com',
  'lerch.ovh',
  'likeageek.fr.nf',
  'loongwin.com',
  'lsyx0.rr.nu',
  'm.cloudns.cl',
  'm.tartinemoi.com',
  'ma.ezua.com',
  'ma.zyns.com',
  'mabal.fr.nf',
  'machen-wir.com',
  'magspam.net',
  'mai.25u.com',
  'mai.dhcp.biz',
  'mail-mario.fr.nf',
  'mail.berwie.com',
  'mail.hsmw.net',
  'mail.i-dork.com',
  'mail.jab.fr.cr',
  'mail.tbr.fr.nf',
  'mail.xstyled.net',
  'mail.yabes.ovh',
  'mail1a.de',
  'mail34.fr',
  'mailadresi.tk',
  'mailbox.biz.st',
  'mailboxify.ru',
  'mailboxify.store',
  'mailboxly.ru',
  'mailboxly.store',
  'mailboxy.ru',
  'mailboxy.store',
  'mailcurity.com',
  'mailsafe.fr.nf',
  'maxpedia.cloud',
  'mcdomaine.fr.nf',
  'mdz.email',
  'mega.zik.dj',
  'mehr-bitcoin.de',
  'meldedigital.com',
  'mesemails.fr.nf',
  'mess-mails.fr.nf',
  'mexc.gotdns.ch',
  'mickaben.biz.st',
  'mickaben.fr.cr',
  'mickaben.fr.nf',
  'mickaben.xxl.st',
  'miistermail.fr',
  'miloras.fr.nf',
  'mm.8.dnsabr.com',
  'moncourrier.fr.nf',
  'mondial.asso.st',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'mowgli.jungleheart.com',
  'mr-email.fr.nf',
  'msft.cloudns.asia',
  'muell.icu',
  'muell.io',
  'muell.monster',
  'muell.xyz',
  'muellemail.com',
  'muellmail.com',
  'mx.fuppurge.info',
  'mybrosky.com',
  'mymail.infos.st',
  'mymail.ns01.biz',
  'mymailbox.xxl.st',
  'mymaildo.kro.kr',
  'mynes.com',
  'myself.fr.nf',
  'naah.ru',
  'naah.store',
  'naverly.com',
  'nedalmhm.cloud',
  'new.ovh',
  'nhieutienvl.info',
  'nidokela.biz.st',
  'nikora.biz.st',
  'nikora.fr.nf',
  'no-trash.ru',
  'nocp.ru',
  'nocp.store',
  'nomail.xl.cx',
  'nomes.fr.cr',
  'nomes.fr.nf',
  'noreply.fr',
  'nori24.tv',
  'nospam.fr.nf',
  'nospam.ze.tc',
  'now.mefound.com',
  'noyp.fr.nf',
  'nyndt.top',
  'ociun.com',
  'oida.icu',
  'okmail.p-e.kr',
  'oloh.ru',
  'oloh.store',
  'omicron.token.ro',
  'oovk.ru',
  'oovk.store',
  'opentrash.com',
  'otpku.com',
  'packiu.com',
  'pamil.1s.fr',
  'pamil.fr.nf',
  'papierkorb.me',
  'pasdus.fr.cr',
  'pastipass.com',
  'pelagius.net',
  'pflege-schoene-haut.de',
  'picdv.com',
  'pitiful.pp.ua',
  'pitimail.xxl.st',
  'pixelgagnant.net',
  'pizu.ru',
  'pizu.store',
  'pliz.fr.nf',
  'pmail.1s.fr',
  'pokemail.net',
  'pokemons1.fr.nf',
  'popol.fr.nf',
  'postbx.ru',
  'postbx.store',
  'poubelle-du.net',
  'poubelle.fr.nf',
  'prc.cx',
  'profilelocked.com',
  'puppetmail.de',
  'pw.8.dnsabr.com',
  'pw.epac.to',
  'q0.us.to',
  'qianhost.com',
  'quatetaline.com',
  'rackabzar.com',
  'ramenmail.de',
  'ramin200.site',
  'randol.infos.st',
  'rapidefr.fr.nf',
  'rartg.com',
  're-gister.com',
  'readmail.biz.st',
  'red.fr.cr',
  'redi.fr.nf',
  'remailt.com',
  'rhyta.com',
  'romog.com',
  'rygel.infos.st',
  'ryyr.ru',
  'ryyr.store',
  's0ny.net',
  'sake.prout.be',
  'saruawaeah.co.uk',
  'sdj.fr.nf',
  'seagull-soft.site.org.in',
  'sendos.fr.nf',
  'sendos.infos.st',
  'sexy.camdvr.org',
  'sharklasers.com',
  'shit.dns-cloud.net',
  'shit.dnsabr.com',
  'sievid.com',
  'sind-hier.com',
  'sind-wir.com',
  'sindhier.com',
  'sindwir.com',
  'sirttest.us.to',
  'six25.biz',
  'skynet.infos.st',
  'smashmail.de',
  'soleymari.es',
  'spam.9001.ovh',
  'spam.aleh.de',
  'spam.care',
  'spam.ceo',
  'spam.popcorp.eu',
  'spam.quillet.eu',
  'spam4.me',
  'spambog.com',
  'spambog.de',
  'spambog.ru',
  'speed.1s.fr',
  'spoofmail.de',
  'spoofmail.es',
  'spoofmail.fr',
  'ssi-bsn.infos.st',
  'ssl.tls.cloudns.asia',
  'suck.my-vigor.de',
  'sudern.de',
  'suksesboss.com',
  'superrito.com',
  'sweetxxx.de',
  't.woeishyang.com',
  'tagara.infos.st',
  'telegmail.com',
  'teleworm.us',
  'temp.ig96.net',
  'tempmail.giize.com',
  'tempr-mail.line.pm',
  'tempr.email',
  'tempsmtp.com',
  'terre.infos.st',
  'test-infos.fr.nf',
  'test.inclick.net',
  'tester2341.great-site.net',
  'testkkk.zik.dj',
  'tinyios.com',
  'tiscali.fr.cr',
  'tls.cloudns.asia',
  'tmp.x-lab.net',
  'togito.com',
  'tongkosong.com',
  'tonne.to',
  'toolbox.ovh',
  'torrent411.fr.nf',
  'totococo.fr.nf',
  'trap-mail.de',
  'trash-mail.com',
  'trash-me.com',
  'trash.lapier.re',
  'trashmail.de',
  'trashmail.org',
  'tweet.fr.nf',
  'twitch.work',
  'ultra.fyi',
  'upc.infos.st',
  'us.prout.be',
  'vermutlich.net',
  'ves.ink',
  'vigilantkeep.net',
  'vip.222.ac.cn',
  'vip.ep77.com',
  'vivilulioaxu.cfd',
  'vjoid.ru',
  'vjoid.store',
  'vkbb.ru',
  'vkbb.store',
  'vkbt.ru',
  'vkbt.store',
  'vkcbt.ru',
  'vkcbt.store',
  'vkfu.ru',
  'vkfu.store',
  'vkpr.store',
  'vkrr.ru',
  'vkrr.store',
  'vogco.com',
  'warlus.asso.st',
  'web.run.place',
  'webclub.infos.st',
  'webstore.fr.nf',
  'wecp.ru',
  'wecp.store',
  'wegwerf-email.at',
  'wegwerfemail.de',
  'whatagarbage.com',
  'wir-sind.com',
  'wishy.fr',
  'woofidog.fr.nf',
  'wwvk.ru',
  'wwvk.store',
  'www3.freetcp.com',
  'wxcv.fr.nf',
  'wzofit.com',
  'xepa.ru',
  'xkors.com',
  'xxvk.ru',
  'xxvk.store',
  'xylar.ru',
  'xylar.store',
  'y.dldweb.info',
  'y.iotf.net',
  'yahooz.xxl.st',
  'yaloo.fr.nf',
  'yecp.ru',
  'yecp.store',
  'ym.cypi.fr',
  'ym.digi-value.fr',
  'ymail.1s.fr',
  'ymail.ploki.fr',
  'ymail.rr.nu',
  'yofmail.fr',
  'yop.kd2.org',
  'yop.kyriog.fr',
  'yop.mabox.eu',
  'yop.mc-fly.be',
  'yop.moolee.net',
  'yop.smeux.com',
  'yop.too.li',
  'yop.tv-sante.com',
  'yop.uuii.in',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.kro.kr',
  'yopmail.net',
  'yopmail.ozm.fr',
  'yopmail.ploki.fr',
  'yoptruc.fr.nf',
  'yotmail.fr.nf',
  'you-spam.com',
  'your5.ru',
  'your5.store',
  'ypmail.sehier.fr',
  'yummy-fast.fr',
  'ywzmb.top',
  'yx.dns-cloud.net',
  'yxdad.ru',
  'yxdad.store',
  'zcovz.ru',
  'zcovz.store',
  'zimel.fr.cr',
  'zinc.fr.nf',
  'zorg.fr.nf',
  'zouz.fr.nf',
  'zx81.ovh'
];

export const MINDCLOUD_EMBEDDED_COMPANY_ID = 'pSjSczG3NBjE';

export const MINDCLOUD_EMBEDDED_SLACK_INTEGRATION_ID = 'int_2LugJCOiSnHT';
export const MINDCLOUD_EMBEDDED_SENDGRID_INTEGRATION_ID = 'int_UBtdktntTvp1';
export const MINDCLOUD_EMBEDDED_SENDGRID_APP_ID = '0LR3k0MCH8eI';
export const MINDCLOUD_EMBEDDED_SENDGRID_GET_VERIFIED_SENDERS_ACTION_ID = 'ouelpydpprra';
export const MINDCLOUD_EMBEDDED_SENDGRID_SEND_EMAIL_ACTION_ID = 'hcqlnahhamjl';

export const MINDCLOUD_TURNKEY_INTEGRATIONS_COMPANY_ID = '16FavNMhTh3O';

// Seeded system role, guaranteed to exist for every company; the default role for members
// invited without an explicit role choice (e.g. from a share dialog rather than the members page).
export const MEMBER_ROLE_ID = 'smfOe0IC2TlS';

export const SHOW_MAP_AI_AGENT = true;

export const SESSION_STORAGE_KEY = 'sessionCompanyId';
export const SESSION_STORAGE_COMPANY_CHANNEL_KEY = 'sessionCompanyChannel';

/**
 * Keys to exclude from workflow objects when computing hashes or filtering diffs.
 * These are transient or non-meaningful keys that should not affect workflow comparison.
 * @type {string[]}
 */
export const WORKFLOW_DIFF_BLACKLIST_KEYS = [
  'lastSuccessfulStartedOn',
  'lastSuccessfulFinishedOn',
  'lastRunOn',
  'lastRunBy',
  'runCount',
  'lastError',
  'publishedOn',
  'publishedSnapshotId',
  'publishedVersion',
  'publishedBy',
  'updatedOn',
  'updatedBy',
  'createdOn',
  'createdBy',
  'isActive',
  'isValid',
  'isManualSize',
  'size',
  'variables',
  'recentLogs',
  'settings',
  'meta',
  'workflowCompanyId',
  'tutorialSlug',
  'installationId',
  'installationMetadata',
  'integrationId',
  'usesEmbeddedApp',
  'stage',
  'environmentId',
  'viewMode',
  'zoom',
  // Additional exclusions for hash computation
  'name',
  'isPublished',
  'version',
  'description',
  'summary'
];
